import Hl7IntegratorHome from "./pages/Hl7IntegratorHome.vue";
import Hl7IntegratorServer from "./pages/Hl7IntegratorServer.vue";
import Hl7IntegratorClient from "./pages/Hl7IntegratorClient.vue";

export default {
    Hl7IntegratorHome,
    Hl7IntegratorServer,
    Hl7IntegratorClient,
};
